// "X / Y played" for a gate session — one definition for every page that shows
// it (gate queue page, supervisor/manager dashboard), so they always agree.
//   played: actually played
//   total:  everything in the programme except items taken out of it
//           (skipped / cancelled) — includes the one playing right now
// Pass ALL of the session's announcements, whatever their status.
export function sessionProgress(announcements = []) {
  const counted = announcements.filter(a => !['skipped', 'cancelled'].includes(a.status));
  return {
    played: counted.filter(a => a.status === 'played').length,
    total: counted.length,
  };
}
